import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./NotificationPreview.module.css";

interface NotificationCompactPreviewProps {
    shortText?: string;
    fullText?: string;
    logoUrl?: string | null;
    notificationType?: "urgent" | "information" | "redirection";
    plain?: boolean;
}

const NotificationCompactPreview: React.FC<NotificationCompactPreviewProps> = ({
    shortText,
    fullText,
    logoUrl,
    notificationType,
    plain = false,
}) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    // Mock notifications-b: only Urgent keeps the coral card; Information / Redirection use .plain (white)
    const typeClass =
        plain || !notificationType || notificationType !== "urgent"
            ? styles.phonePreviewPlain
            : styles.phonePreviewUrgent;

    const phonePreviewClass = `${styles.phonePreview} ${typeClass}`;

    return (
        <div className={styles.group}>
            <h2>{t("notificationPreview")}</h2>
            <div className={phonePreviewClass}>
                {logoUrl && (
                    <div className={styles.phoneLogo}>
                        <img src={logoUrl} alt="Logo" style={{ width: 40, height: 40, objectFit: "cover" }} />
                    </div>
                )}
                <div className={styles.phoneContent}>
                    {notificationType !== "urgent" && <div className={styles.phoneTime}>{t("twoMinutesAgo")}</div>}
                    <div className={styles.phoneTitle}>{shortText || t("notificationTitle")}</div>
                    <div className={styles.phoneMessage}>{fullText || t("notificationContent")}</div>
                </div>
            </div>
        </div>
    );
};

export default NotificationCompactPreview;
